import { createReducer, on } from "@ngrx/store";
import { sharedCartData } from "../state/cart-details.state";
import { ManageCartsActions } from "../actions";

export const initialState: sharedCartData = {
    duplicateCartIndex: null,
    deleteCartIndex: null,
    deleteCartStatus: null,
    updateCartStatus: null,
    manageCartsPaginationReset: null,
    manageCartsSortFlag: null,
    saveCartsFilter: [],
    saveCartsSort: [],
    saveCartsCurrentPage: null,
};

const sharedCartReducer = createReducer(
    initialState,
    on(ManageCartsActions.setDeleteCartSuccess, (state: sharedCartData, { deleteCartStatus }): sharedCartData => ({
        ...state,
        deleteCartStatus
    })),
    on(ManageCartsActions.setDeleteCartFail, (state: sharedCartData, { deleteCartStatus }): sharedCartData => ({
        ...state,
        deleteCartStatus
    })),
    on(ManageCartsActions.clearDeleteCartState, (state: sharedCartData): sharedCartData => ({
        ...state,
        deleteCartIndex: null,
        deleteCartStatus: null,
    })),
);

export function sharedManageCartsReducer(state, action) {
    return sharedCartReducer(state, action);
}
